import { render, staticRenderFns } from "./app-dialogs.vue?vue&type=template&id=11108fa5&"
import script from "./app-dialogs.vue?vue&type=script&lang=js&"
export * from "./app-dialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports